import { Options, Vue } from "vue-class-component";

@Options({
  name: "reports",
})
export default class Reports extends Vue {}
